export default "__VITE_ASSET__DZjHEwaC__"